import { mergeOldAndNewWords } from "@/common/functions";

/**
 * When the user is unscrambling, and none or less then 3 results are found given the input tiles,
 * the BE will automatically append one or two wildcards to give the user more alternatives.
 *
 * This module is holding this alternative results and the meta information related to it.
 */
export default {
	namespaced: true,
	state: {
		/**
		 * The alternative words, grouped per table.
		 */
		words: {},
		/**
		 * The tiles including the automatically injected wildcards from the API.
		 */
		tiles: "",
		/**
		 * The number of automatically injected wildcards from the API.
		 */
		wildcardsCount: 0,
	},
	mutations: {
		setAlternativeWords: function(state, payload) {
			//If a null payload is given, then we are resetting the words state.
			if (payload === null) {
				state.words = {};
				return;
			}

			let { gameType, data, offset } = payload;

			data = mergeOldAndNewWords(
				state.words,
				offset,
				gameType,
				data,
				payload.order_by
			);

			state.words = {
				...(state.words || {}),
				...data,
			};
		},
		setAlternativeResultsTiles: function(state, payload) {
			state.tiles = payload;
		},
		setAlternativeResultsWildcardsCount: function(state, payload) {
			state.wildcardsCount = payload;
		},
	},
};
